import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isDaily } from "@madmedical/medical";
import { HStack, Text, VStack } from "native-base";
import { formatTime } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import ActionButton from "../ActionButton";
import Badge from "../../atoms/Badge";
const MeasurementListItem = ({ id, displayValue, measuredAt, manual, alertLevel, metricType, deleted, onDeletePress, }) => {
    const { t } = useTranslation();
    const ALERT_LEVELS = {
        0: {
            text: t("measures:unmeasured"),
            variant: "ghost",
        },
        1: {
            text: t("measures:ok"),
            variant: "ghostSuccess",
        },
        2: {
            text: t("measures:warning"),
            variant: "ghostWarning",
        },
        3: {
            text: t("measures:alert"),
            variant: "ghostError",
        },
    };
    return (_jsxs(HStack, Object.assign({ space: 4, justifyContent: "space-between", alignItems: "center", bgColor: "white", px: 4, py: 5.5, borderBottomColor: "gray.100", borderBottomWidth: 1, borderBottomStyle: "solid", width: "full" }, { children: [_jsxs(VStack, { children: [_jsx(Text, Object.assign({ fontSize: "md", fontWeight: "medium" }, { children: displayValue })), _jsxs(HStack, Object.assign({ space: 1.5, alignItems: "center", mt: 1 }, { children: [alertLevel ? (_jsx(Badge, Object.assign({ variant: ALERT_LEVELS[alertLevel].variant, size: "sm" }, { children: ALERT_LEVELS[alertLevel].text }))) : null, !isDaily(metricType) && (_jsx(Text, Object.assign({ lineHeight: 1, fontSize: "xs", color: "gray.600" }, { children: formatTime(measuredAt) }))), manual && !deleted && (_jsx(Badge, Object.assign({ variant: "ghost", size: "xs" }, { children: t("measures:manual") }))), deleted && (_jsx(Badge, Object.assign({ variant: "ghost", size: "xs" }, { children: t("measures:deleted") })))] }))] }), _jsx(ActionButton, { actions: manual && !deleted
                    ? [
                        {
                            text: t("delete"),
                            iconName: "trashCan",
                            onPress: () => {
                                onDeletePress(id);
                            },
                        },
                    ]
                    : [] })] })));
};
export default MeasurementListItem;
